import React from 'react';
import { useEffect, useRef } from 'react';

function ScrollAnimation({ children, className = '' }) {
    const elementRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('fade-up');
                        // Optional: stop observing after animation is triggered
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1, // Trigger when 10% of the element is visible
                rootMargin: '50px' // Trigger slightly before the element comes into view
            }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <div ref={elementRef} className={`scroll-animation ${className}`}>
            {children}
        </div>
    );
}

export default ScrollAnimation